import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { bannerNotiText, commonText } from "../../locales/en";
import ErrorBoundary from "../../components/error-boundary";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";
const BannerNotificationTable = lazy(
  () =>
    import(
      "../../components/table/all-tables/bannernotificationtable/BannerNotificationTable"
    )
);

export default function BannerNotification() {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={bannerNotiText?.mainTitle} />
      <AccessPageAction
        subheading={bannerNotiText?.subheading}
        alluser="/admin/banner-notifications"
        allUserTitle={bannerNotiText?.allUserBtn}
        createuser="/admin/banner-notifications/create"
        createUserTitle={bannerNotiText?.createUserBtn}
      />

      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-2 mb-2 mx-0 ">
          <div className="col-md-12 sale-leade-form">
            <Suspense fallback={<div>{commonText?.fallbackLoader}</div>}>
              <BannerNotificationTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
